module.exports = __webpack_public_path__ + "img/blog.3cda6797.svg";